import { Avatar } from './Avatar.js';

type TypingIndicatorProps = {
  variant?: 'bot' | 'manager';
};

export function TypingIndicator({ variant = 'bot' }: TypingIndicatorProps) {
  const rowClass =
    variant === 'manager'
      ? 'teo-row teo-row--bot teo-row--manager teo-row--typing teo-typing'
      : 'teo-row teo-row--bot teo-row--typing teo-typing';

  return (
    <div className={rowClass} aria-label="Typing">
      <Avatar size="sm" />
      <div className="teo-bubble teo-bubble--typing">
        <span className="teo-typing__dot" />
        <span className="teo-typing__dot" />
        <span className="teo-typing__dot" />
      </div>
    </div>
  );
}
